import React from 'react'

import { noop } from '#util'

type FloatingMenuState = {
  coords: XYCoords | null
  setCoords: (value: XYCoords | null) => void
}

export const Context = React.createContext<FloatingMenuState>({
  coords: null,
  setCoords: noop,
})
